module.exports = __webpack_public_path__ + "static/media/campus_persona.94ae5817.jpg";